import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearch?: (value: string) => void;
}

export function PageHeader({
  title,
  actions,
  showSearch,
  searchPlaceholder = 'Search...',
  onSearch,
}: PageHeaderProps) {
  const hasContent = showSearch || actions;
  if (!hasContent) return null;

  return (
    <div className="px-6 py-3 border-b border-border/60">
      <div className="flex items-center justify-end gap-3">
        {showSearch && (
          <div className="relative mr-auto">
            <Search className="absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground/60" />
            <Input
              placeholder={searchPlaceholder}
              className="pl-9 w-64 h-9 text-[13px] bg-card border-border/70 rounded-full shadow-xs focus-visible:ring-1"
              onChange={(e) => onSearch?.(e.target.value)}
            />
          </div>
        )}
        {actions}
      </div>
    </div>
  );
}
